import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { TodoStateController } from '../services/todo-state.js';
import type { PseudoProject } from '../types/todo.js';
import '../components/shared/cp-page-subnav.js';

const WORK_TABS = [
  { label: 'Projekte', path: '/projects' },
  { label: 'Private Todos', path: '/todos' },
];

@customElement('cp-page-todos')
export class CpPageTodos extends LitElement {
  createRenderRoot() { return this; }

  // TodoStateController for reactive updates
  private _todoState = new TodoStateController(this);

  @state() private _selectedProjectId = 0;

  private _onProjectChanged(e: CustomEvent): void {
    const project = e.detail?.project as PseudoProject | undefined;
    if (project) {
      this._selectedProjectId = project.id;
    }
  }

  render() {
    return html`
      <div class="cp-page cp-page-todos">
        <cp-page-subnav .tabs=${WORK_TABS} activePath="/todos"></cp-page-subnav>
        <h1 class="cp-page__title">Private To-Dos</h1>

        <cp-pseudo-project-selector
          .selectedId=${this._selectedProjectId}
          @pseudo-project-changed=${this._onProjectChanged}
        ></cp-pseudo-project-selector>

        <div class="cp-page-todos__board-area">
          <cp-todo-board
            .pseudoProjectId=${this._selectedProjectId}
          ></cp-todo-board>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-todos': CpPageTodos;
  }
}
